import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as TagReducers from '../reducers/tag.reducer';
import * as GroupTagActions from '../actions/group-tag.actions';
import * as GroupTagSelectors from '../selectors/group-tag.selectors';
import { Observable } from 'rxjs';
import { GroupTag } from '@sleipai/sleip-models';

@Injectable()
export class GroupTagStoreFacade {
  constructor(private readonly store: Store<TagReducers.State>) {}

  fetchGroupTagsForUserGroup$ = (groupId: string) =>
    this.store.dispatch(GroupTagActions.loadGroupTagsForGroup({ groupId }));

  getGroupTagForGroup$ = (groupId: string): Observable<GroupTag[] | null> =>
    this.store.pipe(
      select(GroupTagSelectors.selectGroupTagsByGroupId(groupId))
    );

  getGroupTagByTagId$ = (groupTagId: string): Observable<GroupTag | null> =>
    this.store.pipe(
      select(GroupTagSelectors.selectGroupTagByTagId(groupTagId))
    );
}
